{
    "api_keys": {
        "title": "API Keys",
        "generate_title": "Generate API Key",
        "label": "Label",
        "all_companies": "All sub-companies",
        "specific_companies": "Specific sub-companies",
        "companies": "Companies",
        "select_companies": "Select companies",
        "api_key_label": "API Key",
        "columns": {
            "label": "Label",
            "api_key": "API key",
            "name": "Name",
            "client_id": "Client ID",
            "companies": "Companies",
            "created": "Created",
            "expires": "Expires",
            "last_used": "Last used",
            "status": "Status"
        }
    },
    "card_feature": "Card feature",
    "liquidity_management_feature": "Liquidity feature",
    "about": "About",
    "yes": "Yes",
    "no": "No",
    "release_order": "Release order",
    "action": "Action",
    "amount": "Amount",
    "approval_needed": "Approval needed",
    "approval_pending": "Approval pending",
    "approval_pending_for_my_requests": "Approval pending for my requests",
    "approval_needed_purchase_order": "Approval needed for purchase order",
    "approval_needed_purchase_from": "Purchase approval needed from",
    "approval_needed_invoice_from": "Invoice approval needed from",
    "approved_by": "Approved by",
    "approved": "In review",
    "approver": "Approver",
    "procurement": "Procurement",
    "next_approver": "Next approver",
    "second_approver": "2nd approver",
    "docs_needed": "Documents needed",
    "approval_pending_desc": "You can send a reminder to the approver.",
    "approval_confirmation": "Approve this request?",
    "approval_confirmation_desc": "The requester will be notified.",
    "approval_confirmation_non_approver": "In approval needed state.",
    "approval_confirmation_desc_non_approver": "The approver was notified and will process this request soon.",
    "review_confirmation": "Mark as reviewed?",
    "review_confirmation_desc": "Please make sure the data matches the invoice.",
    "vendor_confirmation": "Verify vendor before reviewing",
    "vendor_confirmation_desc": "Please verify vendor <0> {{vendorName}} </0> before reviewing this request.",
    "review_mileage_perdiem_desc": "Please review this request and check if everything is correct.",
    "review_phase": "Request is being reviewed",
    "review_phase_desc": "An admin will make sure that the request data matches the invoice data.",
    "mark_confirmation": "Mark as paid?",
    "mark_confirmation_desc": "Please make sure that a payment was issued first.",
    "pay_confirmation": "Pay this expense?",
    "pay_confirmation_desc": "When you're ready, pay this request.",
    "pay_phase": "Extracted for payment",
    "pay_phase_desc": "An admin will process a payment for this request.",
    "sepa_xml_confirmation": "Generate SEPA XML?",
    "sepa_xml_confirmation_desc": "This will download a SEPA XML for payment.",
    "export_sepa": "SEPA-XML Export",
    "export_non_sepa": "NON-SEPA-XML Export",
    "export_confirmation": "Export request",
    "export_confirmation_desc": "This will download a ZIP file and archive the request.",
    "expense_deleted": "Deleted request",
    "expense_deleted_desc": "This request has been deleted.",
    "expense_rejected": "Rejected request",
    "expense_rejected_desc": "This request has been rejected.",
    "expense_archived": "Archived Request",
    "expense_archived_desc": "This request has been processed and archived.",
    "export_phase": "Request to be exported",
    "export_phase_desc": "This request is to be exported by an admin.",
    "approved_request": "Past request",
    "past_request": "Past request",
    "past_request_desc": "This request is processed and archived.",
    "article": "Article",
    "beta": "Beta",
    "bic": "BIC",
    "billing_period": "Billing period",
    "budget": "Budget",
    "budgets": "Budgets",
    "budget_detail": {
        "status": "Spending compared to budget",
        "above_budget": "Above budget",
        "within_budget": "Within budget"
    },
    "city": "City",
    "columns": "Columns",
    "contact_person": "Contact person",
    "cost_center_camelcase": "CostCenter",
    "cost_center_id": "Cost center 1 ID",
    "min_cost_center_id": "Min Cost center 1 ID",
    "max_cost_center_id": "Max Cost center 1 ID",
    "cost_center": "Cost center 1",
    "cost_centers": "Cost centers 1",
    "costs_over_time": "Costs over time",
    "costs_over_time_in": "Costs over time ({{unit}})",
    "creation_date": "Created at",
    "current_expenses": "Expenses so far",
    "currency": "Currency",
    "date_of_birth": "Date of birth",
    "declined": "Rejected",
    "delivery_note": "Delivery note",
    "delivery_data": "Delivery data",
    "delivery_date": "Delivery date",
    "delivery_location": "Delivery location",
    "created_on": "Created on",
    "description": "Description",
    "documents_needed": "Documents needed",
    "documents_needed_from": "Documents needed from",
    "finway_app": "finway App",
    "phoneNumberVerified": "Phone number verified",
    "email": "Email",
    "employee": "Employee",
    "employees": "Employees",
    "user": "User",
    "users": "Users",
    "enrolled_in_card_program": "Enrolled in card program",
    "expenses_by_cost_center": "Expenses over time",
    "expenses": "Expenses",
    "team_expenses": "Team Expenses",
    "expense": "Expense",
    "failed_to_load_files": "Failed to load files.",
    "failed_to_load_single_file": "Failed to load file.",
    "first_name": "First name",
    "global_currency": "Global currency",
    "hired_on": "Hired on",
    "iban": "IBAN",
    "taxNumber": "Tax number",
    "vatNumber": "VAT number",
    "id": "ID",
    "invoice_pending": "Invoice approval pending",
    "invoice_request_desc": "Get an invoice approved and paid",
    "invoice_request": "Invoice request",
    "reimbursement_request_desc": "Get an expense reimbursement",
    "reimbursement_request": "Reimbursement request",
    "reimbursement_pending": "Reimbursement pending",
    "reimbursement": "Reimbursement",
    "invoice": "Invoice",
    "e_invoice": "E-Invoice",
    "min_expenses": "Min expenses",
    "max_expenses": "Max expenses",
    "last_name": "Last name",
    "limit_x_approver": "Limit {{x}} Approver",
    "limit_x_per_purchase": "Limit {{x}} per purchase",
    "limits": "Limits",
    "limit_up_to": "Up to",
    "link": "Link",
    "location": "Location",
    "monthly_price": "Monthly price",
    "net_monthly_price": "Monthly net price",
    "monthly": "Monthly",
    "name": "Name",
    "no_doc_preview": "No document preview available.",
    "one_time_purchase": "One-time purchase",
    "one_time": "One-time",
    "order_description": "Order description",
    "orders": "Orders",
    "page": "Page",
    "password": "Password",
    "passcode": "Finway PIN",
    "passcode_update": "Finway PIN update",
    "passcode_recovery": "Finway PIN recovery",
    "past_expenses": "Past expenses",
    "payment": "Payment",
    "address": "Address",
    "pending_requests": "Pending requests",
    "phone": "Phone",
    "position": "Position",
    "profile_image": "Profile image",
    "public_profile": "Public profile",
    "profile": "Profile",
    "purchase_pending": "Purchase approval pending",
    "purchase_request_desc": "Submit a new purchase request",
    "purchase_request": "Purchase request",
    "purchase": "Purchase",
    "quantity": "Quantity",
    "quantity_received": "Quantity received",
    "quantity_short": "Qty.",
    "total_net_price": "Net amount",
    "unit_net_price": "Item net",
    "total_net_amount": "Total net",
    "total_gross_amount": "Total gross",
    "total_gross_amount_with_discount": "Total gross with discount",
    "discounted_price": "Discounted price",
    "net_amount": "Net amount",
    "gross_amount": "Gross amount",
    "total_amount_invoiced": "Total amount invoiced",
    "quarterly": "Quarterly",
    "quarterly_price": "Quarterly price",
    "net_quarterly_price": "Quarterly net price",
    "rating": "Rating",
    "recommendation": "Recommendation",
    "recommendation_set": "Recommendation set",
    "recommendations": {
        "fine": "Fine",
        "blacklisted": "Blacklisted"
    },
    "renewal_date": "Contract renewal date",
    "renewed_on": "Renewed on",
    "cancellation_due_date": "Cancellation due date",
    "submission": "Submitted",
    "total_price": "Total price",
    "total_cost": "Total cost",
    "renews_soon": "Renews soon",
    "request": "Request",
    "requests": "Requests",
    "requested_by": "Requested by",
    "requester": "Requester",
    "responsible_employee": "Responsible employee",
    "shared_via_group_with": "Shared via group with",
    "shared_with": "Shared with",
    "shared_people": "People",
    "review": "Review",
    "role": "Role",
    "system_admin": "SysAdmin",
    "system": "System",
    "starting_date": "Contract starting date",
    "status": "Status",
    "street_address": "Street and Number",
    "subscription": "Subscription",
    "superior": "Superior",
    "superior_set": "Superior set",
    "tax_number": "Tax number",
    "tax_set": "Tax set",
    "vat_set": "VAT set",
    "this_month": "This month",
    "this_quarter": "This quarter",
    "this_year": "This year",
    "tool_settings": "Tool settings",
    "upload_documents": "Upload documents",
    "upload_documents_desc": "The approver will be notified after upload.",
    "vat_number": "VAT number",
    "vendor": "Vendor",
    "vendor_discount": {
        "discount": "Discount",
        "days": "days",
        "days_one": "{{count}} day",
        "days_other": "{{count}} days"
    },
    "expense_discount": {
        "discount_info_1": "Discount: ",
        "discount_info_2": "{{percentage}}% - Due on {{dueDate}} ",
        "discounted_due_date": "Discounted due date",
        "discounted_total_gross": "Discount applied: {{amount}}"
    },
    "derived_vendor": "Derived vendor",
    "vendors": "Vendors",
    "work_phone": "Work phone",
    "yearly_price": "Yearly price",
    "net_yearly_price": "Yearly net price",
    "yearly": "Yearly",
    "zip": "ZIP",
    "country": "Country",
    "country_code": "Country code",
    "invoice_no": "Invoice no.",
    "invoice_date": "Invoice date",
    "internal_invoice_date": "Internal receipt date",
    "internal_invoice_no": "Internal receipt number",
    "invoice_due_date": "Due on",
    "posting_period": "Posting period",
    "invoice_pdf_edited": "Edited",
    "invoice_pdf_original": "Original",
    "recurring": "Recurring",
    "date_paid_at": "Paid on",
    "to_be_paid_at": "To be paid at",
    "to_be_paid": "To be paid",
    "to_be_exported": "To be exported",
    "renewal_expenses": "Recurring expenses",
    "recurring_expense": "Recurring expense",
    "billing_date": "Billing date",
    "attached_expenses": "Attached expenses",
    "contracts": "Contracts",
    "vendor_contracts": "Vendor contracts",
    "vendor_contract_set": "Contract set",
    "contract_document": "Contract document",
    "no_expenses_to_review": "No expenses to review.",
    "no_expenses_to_pay_or_export": "No expenses to pay or export.",
    "no_expenses_to_export": "No expenses to export.",
    "no_expenses": "No expenses available.",
    "invoice_inbox": "Inbox",
    "to_dos": "To-dos",
    "in_progress": "In progress",
    "pay": "Pay",
    "pay_and_export": "Pay & export",
    "export": "Export",
    "done": "Done",
    "exported": "Exported",
    "reviewed": "Reviewed",
    "paid": "Paid",
    "item": "Item",
    "company_name": "Company name",
    "company": "Company",
    "company_settings": "Company settings",
    "feature_settings": "Feature settings",
    "general": "General",
    "dashboard_and_workflows": "Dashboard & Workflows",
    "banking_and_cards": "Banking & Cards",
    "export_and_bookkeeping": "Export & Bookkeeping",
    "companies": "Companies",
    "transaction": "Transaction",
    "transaction_container": {
        "inflow": "Inflow",
        "outflow": "Outflow",
        "archive": "Archive",
        "all": "All"
    },
    "transactions": "Transactions",
    "matched_transaction": "Matched transaction",
    "matched_transaction_options": {
        "matched": "Matched",
        "not_matched": "Not matched"
    },
    "total": "Total",
    "in_review": "In review",
    "processed": "Processed",
    "in_payment": "Extracted for payment",
    "in_export": "To be exported",
    "matching": {
        "auto_matched": "Auto matched",
        "auto_unmatched": "Auto unmatched",
        "manually_matched": "Manually matched",
        "not_matched": "Not matched",
        "request_to_create": "Request to create",
        "manual_review": "Manual review",
        "no_matches": "No matches found.",
        "match_status": "Match status",
        "transaction_status": "Transaction status",
        "scheduled_for": "Scheduled for {{date}}",
        "transaction_tag": {
            "pending": "Pending",
            "completed": "Completed",
            "failed": "Failed",
            "reversal": "Reversal"
        }
    },
    "configure": "Configure",
    "recurring_subscription": "Recurring subscription",
    "budget_period": "Budget period",
    "budget_period_type": {
        "monthly": "Monthly budget",
        "quarterly": "Quarterly budget",
        "yearly": "Yearly budget"
    },
    "budget_currency": "Budget currency",
    "bank_accounts": "Bank accounts",
    "bank_account": "Bank account",
    "bank_account_filter": "Bank account",
    "bank": "Bank",
    "default": "Default",
    "bank_search_results": "Bank search results",
    "creditor_number": "Creditor number",
    "default_creditor_number": "Default creditor number",
    "default_employee_creditor_number": "Default employee creditor number",
    "default_employee_language": "Default employee language",
    "vat_unit": "VAT ({{unit}})",
    "vat": "VAT",
    "vat_title": "VAT",
    "vat_total": "VAT total",
    "expense_accounts": "Expense accounts",
    "expense_account": "Expense account",
    "account_name": "Name",
    "account_code": "Code",
    "cost_centers_2": "Cost centers 2",
    "cost_center_2": "Cost center 2",
    "cost_center_2_name": "Name",
    "cost_center_2_code": "ID",
    "purchased": "Performance date",
    "purchased_on": "Purchased on",
    "selected": "Selected",
    "show_expense_numbers": "Show expense numbers",
    "show_more": "Show more",
    "show_less": "Show less",
    "legend": "Legend",
    "options": "Options",
    "enable_ocr": "OCR",
    "enable_ocr_itemization": "OCR itemization",
    "enable_go_to_next_expense": "Approval: Navigation to next expense",
    "enable_email_notifications": "Email notifications",
    "show_gross": "Show gross amounts",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "disable": "Disable",
    "card_number": "Card number",
    "card": "Card",
    "card_type": "Type",
    "card_mode": "Mode",
    "card_holder": "Card holder",
    "window": "Card frequency",
    "subscription_attached": "Subscription attached",
    "card_attached": "Card attached",
    "balance": "Balance",
    "monthly_spending": "Monthly spending",
    "expires_soon": "Expires soon",
    "additional_interfaces": "Additional interfaces",
    "note": "Note",
    "forecast": "Pending",
    "none": "none",
    "expense_type": "Expense type",
    "min_amount": "Min amount",
    "max_amount": "Max amount",
    "min_budget": "Min Budget",
    "max_budget": "Max Budget",
    "min_limit": "Min limit",
    "max_limit": "Max limit",
    "min_creditor_number": "Min creditor number",
    "max_creditor_number": "Max creditor number",
    "min_date": "Min date",
    "max_date": "Max date",
    "period": "Period",
    "min_invoice_date": "Min invoice date",
    "max_invoice_date": "Max invoice date",
    "min_invoice_due_date": "Min invoice due date",
    "max_invoice_due_date": "Max invoice due date",
    "min_due_date": "Min due date",
    "max_due_date": "Max due date",
    "due_in_days": "Due in",
    "min_date_purchased": "Min purchase date",
    "max_date_purchased": "Max purchase date",
    "min_date_paid_at": "Min paid on date",
    "max_date_paid_at": "Max paid on date",
    "min_date_renewal": "Min Renewal date",
    "max_date_renewal": "Max Renewal date",
    "all_time": "All time",
    "all_times": "All times",
    "current_year": "Current year",
    "current_month": "Current month",
    "paused": "Paused",
    "active": "Active",
    "paused_on": "Paused on",
    "resumed_on": "Resumed on",
    "no_notifications": "No notifications.",
    "unread": "Unread",
    "mark_all_as_read": "Mark all as read",
    "smart_cards": "Cards",
    "smart_card": "Card",
    "smart_card_details": "Card details",
    "available_amount": "Available amount",
    "transaction_limit": "Transaction limit",
    "auto_recharge": "Auto recharge",
    "auto_recharge_trigger_amount": "Auto recharge trigger",
    "low_balance_alert": "Low balance alert",
    "low_balance_alert_trigger_amount": "Low balance trigger",
    "reset_card_on": "Reset card on",
    "transaction_date": "Transaction date",
    "transaction_status": "Transaction status",
    "transaction_matched": "Matching status",
    "transaction_category": "Category",
    "transaction_category_group": "Category Group",
    "transaction_categorization_disabled": "Categorization disabled",
    "connected_expense": "Expense connected",
    "account": "Account",
    "subject": "Subject",
    "possible_expenses": "Possible expenses",
    "matched_expenses": "Matched expenses",
    "due_date": "Due date",
    "probability": "Probability",
    "min_probability": "Min probability",
    "max_probability": "Max probability",
    "probability_short": "Prob.",
    "transaction_to_be_matched": "Transaction to be matched",
    "transaction_to_be_categorized": "Transaction to be categorized",
    "type": "Type",
    "document_type": "Type",
    "number": "Number",
    "connected_accounts": "Connected accounts",
    "transaction_details": "Transaction details",
    "transaction_type": "Transaction type",
    "transaction_source": "Source",
    "transaction_types": {
        "csv_transaction": "CSV transaction",
        "bank_transaction": "Bank transaction",
        "card_transaction": "Card transaction",
        "funding_transaction": "Funding transaction",
        "outgoing_transaction": "Outgoing transaction",
        "internal_transfer": "Internal transfer"
    },
    "card_transaction_type": "Card transaction type",
    "bank_transaction": "Bank transaction",
    "csv_transaction": "CSV file",
    "card_transaction": "Card transaction",
    "security": "Security",
    "rules": "Rules",
    "business_details": "Business details",
    "contact_details": "Contact",
    "tfa": {
        "authenticator": {
            "title": "Two Factor Authentication",
            "title_app": "Authenticator app",
            "title_sms": "SMS",
            "app_description": "You will receive a login code via Authentication App",
            "sms_description": "You will receive a login code via SMS",
            "app_enabled": "App enabled",
            "sms_enabled": "SMS enabled",
            "notice": "If your admin has enabled Single Sign-On (SSO) for this company, then no Two Factor Authentication will be considered when logging in via Google or Azure account login."
        },
        "setup": "Set up",
        "confirm_code": "Enter confirmation code",
        "confirm_code_description": "Please confirm your account by entering the Authentication code sent to your Google or Duo Mobile authenticator app or via SMS.",
        "confirm_code_error": "Wrong or expired validation token",
        "setup_tfa_app_title": "Set up via third-party authenticator",
        "setup_tfa_app_description": "Please use your authentication app (such as Duo Mobile or Google Authenticator) to scan this QR code.",
        "setup_tfa_app_code": "Or enter this code into your authentication app",
        "reset_for_user": {
            "button": "Reset login presets"
        }
    },
    "no_icon_found_for_vendor": "No icon found for this search term.",
    "no_budget_set": "No budget set.",
    "login_error": {
        "remaining_attempt": "attempts remaining before your account is blocked",
        "error": "Error: Incorrect or invalid login credentials",
        "account_blocked": "Error: Account blocked",
        "retry_time": "Please try again in"
    },
    "phone_verification": {
        "title": "Verify phone number",
        "number_description": "By entering your phone number you'll receive an SMS with a verification code",
        "code_description": "Enter the code you've received via SMS",
        "label": "Phone number",
        "sms_request_error": "Could not send verification for this number! Please try again later",
        "invalid_code": "Invalid or expired verification code",
        "verified": "Verified",
        "duplicate_work_phone": "Phone number already exist"
    },
    "notifications": {
        "most_recent": "Most recent",
        "older": "Older",
        "title": "Notifications",
        "email_settings": "General email notifications",
        "bundle": {
            "title": "Bundle",
            "off": "Off",
            "daily": "Daily",
            "weekly": "Weekly",
            "yearly": "Yearly"
        },
        "enable_all_notifications": {
            "title": "Turn on all notifications",
            "description": "All notifications will be turned on."
        },
        "enable_comments_mentions": {
            "title": "Comments & @-mentions",
            "description": "Receive only notifications when you are mentioned directly or mentioned in comments.",
            "tooltip": "Comments in your requests, @-mentions"
        },
        "enable_action_to_call": {
            "title": "Notifications that contain a call to action",
            "description": "Receive only notifications when you are asked to perform an action in finway, e.g. you need to upload an invoice.",
            "tooltip": "Approval needed, Invoice needed, Subscription renewal, Payment due"
        },
        "enable_my_action": {
            "title": "Notifications related to your actions",
            "description": "Receive updates related to your assets or actions in finway, e.g. for requests you created or subscriptions you own.",
            "tooltip": "Your Cost Center 1, your Requests, your Vendors, your Subscriptions, your Cards"
        },
        "ownCardTransactionAlert": {
            "title": "Notifications related to your own card transactions",
            "description": "Receive updates about your card transaction status, e.g. card transaction is pending / was successful."
        },
        "informative": {
            "title": "Informative notifications",
            "description": "Receive additional updates that are not related to your actions or assets in finway, e.g. someone created a new vendor or a new employee has been added to finway.",
            "tooltip": "Invoices, Company, Bank accounts, Employee, Cost center 1, Workflow, Requests, Vendors, Subscription, Cards, Cost center2"
        },
        "advanced_notification": "Advanced notifications",
        "auto_invoice_missing_reminder": "Send automatic reminder for missing invoices every month on the",
        "recurring_invoice_missing_reminder": "Send recurring weekly reminders for all missing invoices after days",
        "received_money_wallet": "Money has been sent to your finway card wallet",
        "wallet_balance": "Wallet balance is less than",
        "wallet_balance_tooltip": "Receive an email if the wallet ballance is below the threshold. Please Only enter positive values.",
        "wallet_balance_negative_amount_warning": "Bitte nur positive Werte eintragen",
        "costcenter_spent_budget": "80 % of a Cost center 1 budget has been spent",
        "card_transaction_status": "Send card transaction success/decline messages",
        "card_transaction_status_tooltip": "You will receive an email for each card transaction within your company.",
        "general_notification": "General company notifications",
        "pending_transactions_alert": "New bank transaction is in pending status for more than 10 days",
        "pending_transactions_alert_tooltip": "When this user-based setting is enabled, an email will be sent out every time a new bank transaction remains in status pending for 10 days or more. In such cases the respective bank can provide more details. This email notification cannot be bundled.",
        "all_notifications": "That's all your notifications from the last week."
    },
    "found_icons": "Please select one of the found icons",
    "modal_footer": {
        "continue": "Continue",
        "return": "Return",
        "cancel": "Cancel"
    },
    "expense_document": {
        "new_document": "New Document",
        "invoice": "Invoice Document",
        "delivery_note": "Delivery Note Document",
        "offer": "Offer Document"
    },
    "date": "Date",
    "spendings": "Spendings",
    "bank_transfer": "Banktransfer",
    "cards": {
        "card_name": "Card name",
        "virtual": "virtual",
        "physical": "physical",
        "card": "Card",
        "created_at": "Created on",
        "credit_cards": "Cards",
        "tag": {
            "ordered": "Ordered",
            "active": "Active",
            "suspended": "Suspended",
            "terminated": "Terminated",
            "reported_stolen": "Reported stolen",
            "reported_lost": "Reported lost",
            "error": "Error"
        },
        "card_type": "Card type",
        "frequency": "Frequency",
        "amount_limit": "Limit",
        "available_balance": "Available balance",
        "spendings": "Spendings",
        "atm_withdrawals": "ATM withdrawals",
        "cashback_enabled": "Cashback enabled",
        "auto_recharge_enabled": "Auto recharge",
        "enabled": "Enabled",
        "disabled": "Disabled",
        "window": {
            "day": "Daily",
            "daily": "Daily",
            "week": "Weekly",
            "weekly": "Weekly",
            "month": "Monthly",
            "monthly": "Monthly",
            "life_time": "Lifetime",
            "lifetime": "Lifetime",
            "transaction": "One-time",
            "one_time": "One-time",
            "quarterly": "Quarterly",
            "quarter": "Quarterly",
            "yearly": "Yearly",
            "year": "Yearly"
        },
        "bank_transfer": "Bank transfer",
        "subscriptions": {
            "available_amount_per_card": "Available amount per card",
            "switch_to_finway_cards": "Switch to finway virtual card and automate your subscription management.",
            "issue_card_requester_not_enrolled": "The subscription requester is not part of the card program therefore no card can be issued.",
            "issue_card_requester_not_enrolled_please_contact": "Please contact {{name}}."
        },
        "waiting_for_card_transaction": {
            "title": "Waiting for card transaction",
            "message": "As soon as we retrieve the card transaction, this request will be updated."
        },
        "virtual_card": "Virtual card",
        "attached_subscription": "Attached subscription",
        "attached_expense": "Attached expense",
        "attached_purchase_order": "Attached purchase order",
        "activation_code": {
            "title": "Activate card",
            "description_title": "Activation code",
            "message": "Please enter the activation code for this card. Your activation code was sent via email to you when you created the card."
        },
        "card_program": "Card program",
        "is_enrolled": "Enrolled",
        "not_enrolled": "Not enrolled",
        "transaction_types": {
            "authorised": "Authorization",
            "declined": "Declined",
            "cancelled": "Cancelled",
            "online_reverse": "Online reverse",
            "manual_close": "Manually closed",
            "authorised_credit": "Authorization (Credit)",
            "sale_purchase": "Sales purchase",
            "cash_withdrawal": "Cash withdrawal",
            "sale_with_cashback": "Sale with cashback",
            "mail_or_telephone_order": "Mail or telephone order",
            "purchase_refund_reversal": "Purchase refund reversal",
            "original_credit_transaction_reversal": "Original credit transaction reversal",
            "cash_withdrawal_reversal": "Cash withdrawal reversal",
            "purchase_refund": "Purchase refund",
            "purchase_reversal": "Purchase reversal",
            "original_credit_transaction": "Original credit transaction",
            "first_chargeback": "First chargeback",
            "first_chargeback_reversal": "First chargeback reversal",
            "first_representment": "First representment",
            "first_representment_reversal": "First representment reversal",
            "second_chargeback": "Second chargeback",
            "second_chargeback_reversal": "Second chargeback reversal",
            "second_representment": "Second representment",
            "arbitration_chargeback": "Arbitration chargeback",
            "balance_inquiry": "Balance inquiry",
            "expired": "Expired",
            "manual_transaction": "Manual transaction"
        },
        "decline_reasons": {
            "physical_not_activated": "Physical not activate",
            "insufficient_balance": "Insufficient balance",
            "cvv_checks_failed": "CVV checks failed",
            "cvv_retries_exceeded": "CVV retries exceeded",
            "card_status_not_allowed": "Card status not allowed",
            "pin_checks_failed": "PIN checks failed",
            "pin_retries_exceeded": "PIN retries exceeded",
            "card_expiry_checks_failed": "Card expiry checks failed",
            "avs_checks_failed": "AVS checks failed",
            "atm_withdrawal_limit_exceeded": "ATM withdrawal limit exceeded",
            "sca_required": "SCA required",
            "auth_rule_checks_failed": "Auth rule checks failed",
            "transaction_not_permitted": "Transaction not permitted",
            "no_reason": "No reason",
            "timeout": "Timeout",
            "owt_sent_successfully_but_refused_by_beneficiary_bank": "Bank rejection. The transaction was rejected and returned by the stated beneficiary bank."
        },
        "mode": {
            "mode": "Mode",
            "prepaid_mode": "Prepaid",
            "debit_mode": "Debit"
        },
        "current_card_limit": "Current card limit",
        "type": {
            "physical": "Physical",
            "virtual": "Virtual"
        },
        "delivery_type": {
            "title": "Delivery method",
            "standard_delivery": "Standard",
            "registered_mail": "Registered mail",
            "courier": "Courier",
            "first_class_mail": "First class mail"
        },
        "update_expense_amount_on_card_transaction": "Auto-adjust expense amounts",
        "card_program_auth": "Card program authentication",
        "card_program_strong_auth": "Strong card program authentication",
        "bin": "BIN",
        "enrollment_not_eligible": "Not eligible",
        "issued_by": "Issued by {{bank}} pursuant to license by {{network}}."
    },
    "attached_card": "Attached card",
    "limit": "Limit",
    "monthly_statement": "Monthly statement",
    "purchase_data": "Purchase data",
    "vendor_data": "Vendor data",
    "set_vendor_rule": "Set vendor rule",
    "vendor_rule": "Vendor rule",
    "payment_term": "Payment term",
    "payment_term_desc": "Payment term (days)",
    "wallet": {
        "wallet_details": "Wallet details",
        "amount_to_be_transferred": "Amount to be transferred",
        "transfer_from": "Transfer from",
        "verification_of_payee": {
            "provided_name": "Name you provided",
            "registered_name": "Registered account name",
            "result": {
                "MATCH": "Match",
                "CLOSE_MATCH": "Close match",
                "NO_MATCH": "No match",
                "NOT_POSSIBLE": "Verification not possible"
            }
        }
    },
    "corporate": {
        "business_address": "Business address"
    },
    "payment_pending": {
        "message": "Payment is in progress",
        "description": "Please only force a transaction status reset if your previous payment was not completed successfully in the payment form. If you completed the payment successfully, please do not start a new payment. Some banks send the payment confirmation with a delay, so it may take up to 5 days for the payment status to be updated.",
        "tag": "Payment pending"
    },
    "payment_successful_transaction_pending": {
        "message": "Payment is successful, but transaction is still pending.",
        "description": "Please refresh to update the transaction status or reset the payment for this expense.",
        "tag": "Payment pending"
    },
    "vat_rate": "VAT rate",
    "bu_code": "BU code",
    "bu_code_name": "BU code name",
    "teams": "Teams",
    "team_users": "Users in team",
    "team": "Team",
    "schedule_payment": "Schedule payment",
    "direct_payment": "Real-time payment",
    "subject_line": "Subject line for expense #{{expenseNumber}} ({{receiver}})",
    "integrations": "Integrations",
    "active_sessions": "Active sessions",
    "devices": "Devices",
    "login": "Login",
    "datev": "DATEV",
    "datev_csv": "DATEV CSV",
    "datev_invoice_csv": "DATEV Invoice CSV",
    "datev_settings": "DATEV Settings",
    "datev_online": "DATEV Unternehmen Online (DUO)",
    "workflows": "Workflows",
    "all": "All",
    "workflow": {
        "workflow": "Workflow",
        "workflow_type": {
            "title": "Workflow type",
            "request": "Request",
            "folder": "Folder"
        },
        "scope": {
            "all": "All request types",
            "purchase": "Purchase requests",
            "invoice": "Invoice requests",
            "reimbursement": "Reimbursement requests",
            "scope": "Scope"
        },
        "request_type": {
            "title": "Request type",
            "all": "All",
            "purchase": "Subscriptions / Purchase",
            "subscription": "Subscriptions",
            "invoice": "Invoice",
            "all_reimbursements": "All reimbursements",
            "standard_reimbursement": "Standard reimbursement",
            "reimbursement": "Reimbursement",
            "mileage_reimbursement": "Mileage reimbursement",
            "hospitality_reimbursement": "Hospitality reimbursement",
            "per_diem_reimbursement": "Per Diem reimbursement",
            "trip_folder": "Folder",
            "purchase_order": "Purchase order"
        },
        "trigger": {
            "trigger": "Trigger",
            "trigger_type": "Trigger type",
            "trigger_objects": "Trigger object(s)",
            "requester": "Requester",
            "vendor": "Vendor",
            "cost_center": "Cost center 1",
            "cost_center_2": "Cost center 2",
            "expense_account": "Expense account",
            "net_amount": "Net amount",
            "all": "All"
        },
        "types_amount": "{{amount}} Types",
        "approver": "Approver",
        "multiple_approvers": "Multiple approvers",
        "condition": {
            "amount": "Condition (amount {{comparison}} {{amount}})",
            "then": "then"
        },
        "operator": {
            "and": "and",
            "or": "or"
        }
    },
    "follow_up_info": "Please select the date you wish to be reminded on",
    "cost_center_group": "Cost center group",
    "parent_cost_center": "Parent cost center",
    "individual_cost_center": "Individual cost center",
    "sub_cost_center": "Sub cost center of",
    "not_set": "Not set",
    "split_noun": "Split",
    "split": "Split",
    "split_net": "Net split",
    "splitted": "Split",
    "omit_special_character": "Special characters may be omitted.",
    "transaction_data": "Transaction data",
    "payment_data_added": "Payment data added",
    "month": "Month",
    "quarter": "Quarter",
    "year": "Year",
    "enter_date_of_birth": "Enter your date of birth",
    "months": "months",
    "quarters": "quarters",
    "years": "years",
    "select_dates": "Select dates",
    "last_&_upcoming_months": "Last and upcoming months",
    "viewing_period": "Viewing period",
    "monthly_view": "Monthly view",
    "quarterly_view": "Quarterly view",
    "yearly_view": "Yearly view",
    "expenses_paid": "Expenses paid",
    "expenses_pending": "Expenses pending",
    "purchase_orders_pending": "Purchase orders pending",
    "performance_period": "Performance period",
    "performance_period_start_date": "Performance period start",
    "performance_period_end_date": "Performance period end",
    "performance_date": "Performance date",
    "budget_left": "Budget left",
    "deleted": "Deleted",
    "spending_within_budget": "Spending within budget",
    "spending_forecast_within_budget": "Spending forecast within budget",
    "spending_above_budget": "Spending above budget",
    "spending_forecast_above_budget": "Spending forecast above budget",
    "transfer": "Wallet transfer",
    "auto_matching_feature": "Auto transaction matching",
    "invoice_auto_matching_feature": "Auto inbox invoice matching",
    "allow_cost_center_2_creation": "Allow cost center 2 creation",
    "is_lexware_export_enabled": "Lexware CSV export",
    "is_non_sepa_xml_export_enabled": "NON SEPA XML export",
    "is_sepa_xml_bulgaria_enabled": "SEPA XML (Bulgaria)",
    "potential_duplicate": "Potential duplicate",
    "potential_duplicate_vendors": "Potential duplicate vendors",
    "new_vendor": "New vendor",
    "tax_id": "Tax ID",
    "steps": "Steps",
    "no_match_found": "No match found.",
    "consultant_number": "Consultant #",
    "client_number": "Client #",
    "skipped": " (Skipped)",
    "allow_workflow_adjustments": "Allow workflow adjustments",
    "tagging_feature_enable": "Enable tagging as a feature",
    "editing_tags_enable": "Enable tagging editing rights for all",
    "employee_labels": {
        "mileage_rate": "Special mileage rate"
    },
    "employee_absence": {
        "absent": "Absent",
        "absence": "Absence",
        "title": "Absent approver(s)",
        "description": "Approver {{name}} is absent until {{date}}. Do you want to wait until they return? If your request is urgent, you can select an alternative approver",
        "approver_absent_until": "{{name}} is absent until {{date}}",
        "wait_for_return": "Can this wait until the return? If your request is urgent, you can select an alternative approver",
        "back_in": "Back in",
        "day": "{{count}} day",
        "day_other": "{{count}} days",
        "purchase_request_hint": " (applies to purchase & invoice approval)",
        "substitute_for_approval": "Substitute for approval"
    },
    "liquidity": {
        "tabs": {
            "cashflow": "Cashflow planning",
            "dashboard": "Dashboard",
            "transaction_categories": "Category settings"
        },
        "cash_forecast": "Cash forecast",
        "forecast": "Forecast",
        "actual": "Actual",
        "plan": "Plan",
        "compared_to_plan": "compared to plan",
        "rule_based_value": "rule based value",
        "manually_added_value": "manually added",
        "scenario": {
            "create": "Create new scenario",
            "edit": "Edit a scenario"
        },
        "forecast_rule": {
            "type": "Type",
            "description": "Description",
            "amount": "Amount",
            "category": "Category",
            "tabs": {
                "cashflow_planning": "Cashflow planning",
                "planned_cashflow": "Planned cashflow"
            }
        },
        "cash_balance": "Cash balance",
        "cashflow_cumulated": "Cashflow cumulated",
        "month_over_month": "MoM",
        "this_month": "This month",
        "this_year": "This year",
        "cash_inflow": "Cash inflow",
        "cash_outflow": "Cash outflow",
        "cash_actual_vs_forecast": "Cash - Actual vs. Forecast",
        "cash_in_all_bank_accounts": "Cash in all bank accounts",
        "overall_expenses_by_main_categories": "Overall expenses by main categories",
        "total_spending_compared_to_plan": "Total spending compared to plan",
        "vs_plan": "vs. Plan",
        "return": "Back to liquidity dashboard",
        "actual_spending": "Actual spending",
        "forecast_spending": "Forecast spending",
        "cash_in_actual": "Cash in (actual)",
        "cash_out_actual": "Cash out (actual)",
        "cash_in_forecast": "Cash in (forecast)",
        "cash_out_forecast": "Cash out (forecast)",
        "balance": "Balance",
        "bank_name": "Bank name",
        "account_name": "Account name",
        "forecast_conflict_warning": "Your input conflicts with the rules",
        "forecast_conflict_tooltip_message": "Rule-based value (<0 />) has been manually overwritten. To revert, please add the rule-based value manually.",
        "directly_allocated_to_parent_category": "Directly allocated to {{categoryName}}: <0 />.",
        "actual_spending_vs_forecast": "Actual spending compared to plan: "
    },
    "refund": "Refund",
    "credit_note": "Credit note",
    "address_line": "Street name and number",
    "delivery_address": "Delivery address",
    "business_address": "Business address",
    "same_as_business_address": "Same as the business address.",
    "features": "Features",
    "phone_number": "Phone number",
    "missing_invoices": "Missing invoice",
    "missing_invoices_desc": "You can send a reminder to the requester.",
    "bulk_data_upload": "Bulk data upload",
    "created": "Created",
    "ignored": "Ignored",
    "errors": "Errors",
    "troubleshooting": "Troubleshooting",
    "tool_settings_security": "Tool settings & security",
    "payment_settings": {
        "title": "Subscription & billing",
        "plan": "Subscription plan",
        "payment": "Payment method",
        "invoices": "Invoices",
        "usage_consumption": "Requests",
        "intervals": {
            "monthly": "Monthly",
            "yearly": "Yearly"
        },
        "per_card_interval": {
            "monthly": "per month",
            "yearly": "per year"
        },
        "discount": "Discount",
        "discount_until": "until",
        "already_paid": "Already paid",
        "per_card": "per card",
        "billing_plan": "Billing plan",
        "billing_period": "Billing period",
        "billing_plans_missing": "Coming soon...stay tuned!",
        "physical_cards": "Physical cards",
        "card_prices_title": "Card prices",
        "card_prices_number": "Cards",
        "card_prices_monthly": "Monthly",
        "card_prices_yearly": "Yearly",
        "enterprise": "Enterprise",
        "trial": "Trial",
        "trial_upgrade_header": "Upgrade your package",
        "trial_upgrade_message": "Claim full access to get your financial processes covered.",
        "card_payment": "Card payment",
        "sepa_direct_debit": "SEPA direct debit",
        "card_number": "Card number",
        "expiration_date": "Expiration date",
        "cvc": "CVC",
        "email": "Email",
        "second_email": "Second email",
        "name": "Name",
        "iban": "IBAN",
        "invoice_address": "SEPA - Invoice address",
        "second_address": "2nd address line",
        "postcode": "Postcode",
        "city": "City",
        "country": "Country code (two letters, e.g. DE)",
        "invoice_no": "Invoice No"
    },
    "timezone": "Time zone",
    "archive": "Archive",
    "reason_of_the_request": "Reason of the request",
    "no_reason": "No reason",
    "inflow": "Inflow",
    "outflow": "Outflow",
    "parent_transaction_category": "Parent transaction category",
    "categories": "Categories",
    "vendor_creation_for_all": "Vendor creation for all users",
    "add_audit_trail_to_invoice_export": "Generate audit trail as additional attachment",
    "archiveExpensesAfterXDays": "Archive expenses automatically after",
    "archiveTransactionsAfterXDays": "Archive transactions automatically after",
    "archived": "Archived",
    "manually_unarchived": "Manually unarchived",
    "days": "Days",
    "user_integrations": "User integrations",
    "company_integrations": "Company integrations",
    "get_my_invoices": "GetMyInvoices",
    "user_id": "User",
    "min_upload_date": "Min upload date",
    "max_upload_date": "Max upload date",
    "uploaded_by": "Uploaded by",
    "vendor_name": "Vendor",
    "simulator": "Simulator",
    "csv_delimiter": "CSV delimiter",
    "csv_delimiter_type": {
        "comma": "Comma {,}",
        "semicolon": "Semicolon {;}"
    },
    "number_separator": "CSV decimal separator",
    "number_separator_type": {
        "comma": "Comma {,}",
        "dot": "Fullstop {.}"
    },
    "export_format": {
        "title": "Export format",
        "csv": "Exported as CSV",
        "not_csv": "Not exported as CSV",
        "datev_xml": "Exported to DATEV XML",
        "not_datev_xml": "Not exported to DATEV XML",
        "datev_invoice_csv": "Exported as DATEV Invoice CSV",
        "not_datev_invoice_csv": "Not exported to DATEV Invoice CSV",
        "datev_online": "Exported to DUO",
        "not_datev_online": "Not exported to DUO",
        "all_datev": "Exported to DUO or DATEV XML",
        "not_all_datev": "Not exported to DUO and DATEV XML"
    },
    "debtor": "Debtor",
    "derived_debtor": "Derived debtor",
    "upgrade": "Upgrade",
    "get_free_demo": "Get your free demo",
    "being_exported_to_duo": "Is being exported to DUO",
    "export_to_duo_failed": "DUO export failed",
    "custom": {
        "for_you": "for you",
        "for_user": "for user {{userName}}"
    },
    "language": "Language",
    "german": "German",
    "english": "English",
    "date_due_in_badge": {
        "in_x_days": "in {{numberOfDays}} days",
        "overdue": "overdue",
        "due_today": "due today",
        "due_tomorrow": "due tomorrow"
    },
    "reimbursement_type": "Reimbursement type",
    "reimbursement_types": {
        "standard": "Standard",
        "standard_reimbursement": "Standard",
        "mileage": "Mileage",
        "hospitality": "Hospitality",
        "per_diem": "Per diem"
    },
    "expense_types": {
        "standard_reimbursement": "Standard reimbursement",
        "mileage_reimbursement": "Mileage reimbursement",
        "hospitality_reimbursement": "Hospitality reimbursement",
        "per_diem_reimbursement": "Per diem reimbursement",
        "invoice_request": "Invoice request"
    },
    "mileage": {
        "reason": "Description/Reason for Mileage",
        "return_type": "One way/return",
        "date": "Date of mileage",
        "invoice_date": "Internal receipt date",
        "return_date": "Date of return",
        "distance": "Distance",
        "duration": "Duration",
        "vehicle": "Vehicle",
        "amount": "Reimbursable amount",
        "billable": "Reimbursable",
        "start_address": "Start address",
        "destination_address": "Destination address",
        "one_way": "One way",
        "return": "Return/Roundtrip",
        "reimbursable": "Reimburseable",
        "vehicle_type": {
            "motorcycle": "Motorcycle",
            "car": "Car"
        },
        "trip_information": "Trip information",
        "distance_buffer": "Mileage reimbursement distance buffer",
        "setup": "Set up",
        "summary": "Summary",
        "map": "Map",
        "additional_distance_reason": "Additional distance reason",
        "stops": "stops",
        "x_stops": "{{count}} stops"
    },
    "hospitality": {
        "merchant": "Merchant",
        "tip": "Tip",
        "date": "Hospitality date",
        "attendees": "Attendees",
        "reason": "Description/Reason for hospitality",
        "beverages": "Food / drinks"
    },
    "per_diem": {
        "half_day_start": "Half day",
        "half_day_return": "Half day",
        "full_day": "Full day",
        "breakfast": "Breakfast",
        "lunch": "Lunch",
        "dinner": "Dinner",
        "invoice_date": "Internal receipt date",
        "accommodation": "Accommodation",
        "reimbursement": "Reimbursement",
        "day": "Day",
        "allowance": "Allowance",
        "reason": "Description/Reason for trip",
        "destination": "Main destination (city)",
        "start_date": "Start date",
        "end_date": "End date",
        "time": "Time",
        "billable": "Billable",
        "amount": "Reimbursable amount",
        "transfer_date": "Transfer date",
        "additional_destinations": "Additional destinations"
    },
    "folder": {
        "description": "Description/Reason for trip",
        "main_destination": "Main destination",
        "start_date": "Start date",
        "trip_start_date": "Trip start date",
        "time": "Time",
        "return_date": "End date",
        "total": "Folder total",
        "folder": "Folder",
        "details": "Folder details",
        "trip_folder_details": "Trip folder details",
        "submitted_on": "Submitted on",
        "summary": "Summary"
    },
    "pdf_viewer": {
        "match_case": "Match case",
        "whole_words": "Whole words",
        "previous_match": "Previous match",
        "next_match": "Next match",
        "close": "Close"
    },
    "roles": {
        "title": "Roles",
        "global_rights": "Global Rights",
        "standard_rights": "Standard Rights",
        "detailed_rights": "Detailed Rights",
        "resource": "Function",
        "access_rights": "Viewing Rights",
        "action_rights": "Editing Rights",
        "default_menu_info": "The areas $t(nav:dashboard), $t(nav:subscriptions), $t(nav:credit_card), $t(nav:cost_centers) and $t(nav:employees) are visible for all users."
    },
    "rights": {
        "resource": {
            "requests": "Requests",
            "formal_review": "Review",
            "pay": "Payment",
            "export": "Export",
            "subscriptions": "Subscriptions",
            "cards": "Cards",
            "transactions": "Transactions",
            "employees": "Employees",
            "cost_centers": "Cost Center",
            "vendors": "Vendors",
            "workflows": "Workflows",
            "liquidity": "Liquidity",
            "reporting": "Reporting",
            "global_insights": "Global Insights",
            "settings": "Settings",
            "procurement": "Procurement"
        },
        "global_no_editing_rights": {
            "title": "No editing rights",
            "tooltip": "Revokes all editing rights from the role."
        },
        "global_viewing_right": {
            "title": "Viewing right",
            "tooltip": "Authorizes to view any data within the company.",
            "gobd_tooltip": "Authorizes to view any data within the company and to export the Change history."
        },
        "global_inbox_invoices": {
            "title": "Inbox Management",
            "tooltip": "Authorizes to view and assign all uploaded documents in the inbox."
        },
        "global_request_on_others_behalf": {
            "title": "Create requests on behalf of other users",
            "tooltip": "Authorizes to create requests on the behalf of other employees."
        },
        "global_selectable_as_approver": {
            "title": "Selectable as approver in requests & workflows"
        },
        "standard_upload_invoices": {
            "title": "Upload invoices"
        },
        "standard_create_expenses": {
            "title": "Create requests"
        },
        "standard_suggest_vendors": {
            "title": "Suggest vendors",
            "tooltip": "During request creation, Vendors can be suggested."
        },
        "approval_viewingright1": {
            "tooltip": "Viewing right for all requests within the company."
        },
        "approval_viewingright2": {
            "tooltip": "Viewing right for all team requests within the company."
        },
        "review_viewingright1": {
            "tooltip": "Viewing rights for the review area."
        },
        "pay_viewingright1": {
            "tooltip": "Viewing rights for the pay & export area and payments according to the viewing rights on requests."
        },
        "export_viewingright1": {
            "tooltip": "Viewing rights for the pay & export area and exports  according to the viewing rights on requests."
        },
        "subscriptions_viewingright1": {
            "tooltip": "Viewing rights for all subscriptions and authorization to export the subscriptions list."
        },
        "subscriptions_viewingright2": {
            "tooltip": "Viewing rights for all team-subscriptions."
        },
        "cards_viewingright1": {
            "tooltip": "Viewing rights for all cards and related requests (company-wide)."
        },
        "cards_viewingright2": {
            "tooltip": "Viewing rights for all team cards and related requests."
        },
        "cards_viewingright3": {
            "tooltip": "Viewing rights for the card wallet and its balance and account statements."
        },
        "transactions_viewingright1": {
            "tooltip": "Viewing rights for the transaction area and transactions."
        },
        "emplyees_viewingright1": {
            "tooltip": "Viewing rights for detailed information of all employees of the company."
        },
        "employees_viewingright2": {
            "tooltip": "Viewing rights for detailed information of team members."
        },
        "costcenter1_viewingright1": {
            "tooltip": "Viewing rights for cost center 1 depending on viewing rights on requests."
        },
        "vendors_viewingright1": {
            "tooltip": "Viewing rights for the vendor area and authorization to export the vendor list."
        },
        "vendors_viewingright2": {
            "tooltip": "Viewing rights for vendor payment data."
        },
        "vendors_viewingright3": {
            "tooltip": "Viewing rights for vendor contracts."
        },
        "workflows_viewingright1": {
            "tooltip": "Viewing rights for the workflows area."
        },
        "liquidity_viewingright1": {
            "tooltip": "Viewing rights for the liquidity area."
        },
        "reporting_viewingright1": {
            "tooltip": "Viewing rights for the reporting area."
        },
        "global_insights_viewingright1": {
            "tooltip": "Access to Global Insights, which reports on company-wide data."
        },
        "settings_viewingright1": {
            "tooltip": "Viewing rights for the feature settings."
        },
        "settings_viewingright2": {
            "tooltip": "Viewing rights for the following accounting related settings: Expense accounts, cost center 2, VAT, teams, Tags and DATEV integration."
        },
        "settings_viewingright3": {
            "tooltip": "Viewing rights for bank accounts within the company."
        },
        "approval_requests": {
            "title": "Requests",
            "tooltip": "Authorizes to approve, reject and edit company-wide requests."
        },
        "approval_requests_status": {
            "title": "Request Status",
            "tooltip": "Authorizes to edit the status of requests (company-wide)."
        },
        "approval_requests_team": {
            "title": "Team-Requests",
            "tooltip": "Authorizes to approve, edit and reject team requests."
        },
        "approval_requests_status_team": {
            "title": "Request Status Team",
            "tooltip": "Authorizes to edit the status of team requests."
        },
        "approval_dashboard": {
            "title": "Dashboard",
            "tooltip": "Authorizes to approve and reject requests directly from the overview area in the dashboard."
        },
        "review_requests": {
            "title": "Requests",
            "tooltip": "Authorizes to review requests."
        },
        "payment_requests": {
            "title": "Requests",
            "tooltip": "Authorizes to pay requests."
        },
        "export_requests": {
            "title": "Requests",
            "tooltip": "Authorizes to exporting requests in different formats (e.g., CSV files, DATEV, [...])."
        },
        "subscriptions_company": {
            "title": "Company",
            "tooltip": "Authorizes to create, edit, and delete subscriptions (company-wide)."
        },
        "subscriptions_team": {
            "title": "Team",
            "tooltip": "Authorizes to create, edit, and delete team subscriptions."
        },
        "cards_company": {
            "title": "Company",
            "tooltip": "Authorizes to edit and issue cards (company-wide)."
        },
        "cards_team": {
            "title": "Team",
            "tooltip": "Authorizes to edit and issue team cards."
        },
        "cards_wallet": {
            "title": "Wallet",
            "tooltip": "Authorizes to fund the wallet, initiate the KYB process, enable and receive notifications and regenerate account statements."
        },
        "transactions_manage": {
            "title": "Manage",
            "tooltip": "Authorizes to add, edit and delete transactions through imports or bank connections, as well as matching transactions with requests."
        },
        "employees_manage": {
            "title": "Manage",
            "tooltip": "Authorizes to manage detail data for all employees (company-wide)."
        },
        "employees_conditions": {
            "title": "Conditions",
            "tooltip": "Authorizes to manage the conditions (e.g., cost centers and rules) of all employees (company-wide)."
        },
        "employees_manage_team": {
            "title": "Manage (Team)",
            "tooltip": "Authorizes to manage detail data of team members."
        },
        "employees_conditions_team": {
            "title": "Conditions (Team)",
            "tooltip": "Authorises to manage the conditions of team members (e.g. cost centres and rules)."
        },
        "costcenter1_manage": {
            "title": "Manage",
            "tooltip": "Authorizes to manage, edit, and delete cost centers and budgets."
        },
        "costcenter1_approval": {
            "title": "Approval",
            "tooltip": "Authorizes to be added as an owner of a cost center."
        },
        "vendors_manage": {
            "title": "Manage",
            "tooltip": "Authorizes to approve, edit and delete vendors."
        },
        "vendors_paymentdata": {
            "title": "Payment Data",
            "tooltip": "Authorizes to edit, or delete payment details for all vendors."
        },
        "vendors_contracts": {
            "title": "Contracts",
            "tooltip": "Authorizes to upload or delete vendor contracts."
        },
        "workflows_manage": {
            "title": "Manage",
            "tooltip": "Authorizes to manage workflows."
        },
        "workflows_overwrite": {
            "title": "Overwrite",
            "tooltip": "Authorizes to override active workflows in a specific request."
        },
        "liquidity_manage": {
            "title": "Manage",
            "tooltip": "Authorizes to manage the liquidity area."
        },
        "feature_settings_manage": {
            "title": "Feature Settings",
            "tooltip": "Authorizes to edit the feature settings."
        },
        "accounting_settings_manage": {
            "title": "Accounting Settings",
            "tooltip": "Authorizes to edit the following accounting related settings: Expense Accounts, Cost Center 2, VAT, Teams and DATEV integration. In addition, it enables to create and delete tags."
        },
        "settings_bankaccounts": {
            "title": "Bank Accounts",
            "tooltip": "Authorizes to add, edit and delete bank accounts."
        },

        "procurement_viewing_right": {
            "tooltip": "Viewing rights for the Procurement area and all purchase orders in procurement states ({{states}})."
        },

        "procurement_manage_right": {
            "tooltip": "Authorizes to release orders.",
            "title": "Purchase order"
        },
        "delivery_note_viewing_right": {
            "tooltip": "Viewing rights for all delivery notes within the company."
        },
        "delivery_note_update_right": {
            "title": "Delivery note",
            "tooltip": "Authorizes to edit and delete company-wide delivery notes."
        }
    },
    "per_diem_calculation": "Per diem calculation",
    "trip_map": "Trip map",
    "tag": "Tag",
    "tags": "Tags",
    "available": "<0></0> available",
    "above_limit": "<0></0> above limit",
    "payment_type": "Payment type",
    "sub_company_email_aliases": "Company email aliases",
    "no_email_alias_set": "No email alias set",
    "add_email_alias": "Add a company email alias",
    "alternative_email_address_required": "Alternative email address required",
    "or": "or",
    "csv_settings": {
        "custom_csv_template": "Custom CSV Template",
        "set_up": "Set up",
        "add_field": "Add field",
        "total_templates": "Total {{numberOfTemplates}} templates",
        "edit": "Edit existing",
        "new": "Create new"
    },
    "auto_logout": {
        "title": "Inactivity logout",
        "fifteen_minutes": "After 15 minutes",
        "one_hour": "After 60 minutes",
        "one_work_day": "After 1 day (8 hours)",
        "one_full_day": "After 1 day (24 hours)"
    },
    "fiscal_year": "Fiscal year",
    "custom_bank_subject": {
        "title": "Custom bank subject",
        "invoice_number": "Invoice number",
        "expense_number": "Expense number",
        "vendor_name": "Vendor",
        "description": "Description",
        "request_items": "Request items",
        "not_set": "Not set"
    },
    "pdf": "PDF",
    "payment_flow_information": {
        "title": "Payment status",
        "not_set": "Not set",
        "already_paid": "Already paid (e.g. SEPA)",
        "already_approved_and_paid": "Already approved & paid",
        "reporting_only": "Reporting only"
    },
    "expense_payment_flow_information": {
        "is_already_approved_and_paid_enabled": "Enable \"Approved & paid\" process (skip approval & payment)",
        "is_already_paid_enabled": "Enable \"Already paid\" process (skip payment)",
        "is_report_only_enabled": "Enable \"Report only & paid\" process (skip approval, payment & export)"
    },
    "debit_card_limit_buffer": "Debit card limit buffer",
    "set_employee_rule": "Set employee rule",
    "set_employee_limits": "Set employee limits",
    "vendorRulesShouldOverwrite": "Vendor rules should overwrite employee rules",
    "allow_all_to_update_absences": "Vacation & illness replacement: Allow all users to set up their absences",
    "show_cost_centers_ids": "Show cost center 1 IDs in all drop down menus",
    "amount_payable": "Amount payable (gross)",
    "show_auto_approver_warning": "Auto approver warning",
    "custom_datev_modal": "Custom DUO information & booking text",
    "custom_datev_booking": "DATEV booking text",
    "custom_datev_information": "Custom DATEV Information",
    "custom_datev_settings": "Custom DATEV information & booking text",
    "root_company": "Root company",
    "comment_date_time_format": "MMM D, YYYY, HH:mm",
    "request_status": "Request status",
    "request_details": "Request details",
    "n/a": "N/A",
    "not_provided": "Not provided",
    "provided": "Provided",
    "standard_reimbursement": "Standard reimbursement",
    "mileage_reimbursement": "Mileage reimbursement",
    "per_diem_reimbursement": "Per diem reimbursement",
    "hospitality_reimbursement": "Hospitality reimbursement",
    "all_reimbursements": "All reimbursements",
    "filter_presets": {
        "overdue_invoices": "Overdue invoices",
        "my_todo": "My To-dos",
        "my_requests": "My requests",
        "follow_up_requests": "Follow-up requests",
        "draft_trip_folder": "All trip folder drafts",
        "my_mentions": "My mentions"
    },
    "quick_filter": "Quick filter",
    "fallback_approver": "Fallback approver",
    "define_fallback_approver": "Define workflow fallback approver",
    "approvals": "Approvals",
    "purchase_approval": "Purchase approval",
    "invoice_approval": "Invoice approval",
    "file_download": "Your {{fileName}} download will begin shortly",
    "renewal_generation": {
        "title": "Recurring request generation",
        "by_date": "By date",
        "by_transaction": "By transaction"
    },
    "created_by": "Created by",
    "date_created": "Date created",
    "company_identifier": "Company Identifier",
    "update_expense_amount_on_card_transaction": "Auto-adjust amounts",
    "logout": "Logout",
    "purchase_submit_confirmation": "Submit this purchase request?",
    "invoice_submit_confirmation": "Submit this invoice request?",
    "folder_submit_confirmation": "Submit this trip folder?",
    "request_submit_confirmation_description": "Please make sure all data is correct and complete. This will notify the approvers.",
    "folder_submit_confirmation_description": "Please collect all expenses before submitting. This will notify the approvers.",
    "recalculate_approval_process_after_amount_changes": "Reset and recalculate approval process in progress after amount in a request changes.",
    "recalculate_approval_process_after_folder_amount_changes": "Reset and recalculate approval process in progress after amount in a folder changes.",
    "recalculate_approval_process_after_other_changes": "Reset and recalculate approval process in progress, after certain changes in a request.",
    "recalculate_approval_process_after_folder_other_changes": "Reset and recalculate approval process in progress, after certain changes in a folder.",
    "approval_process_status": {
        "not_started": "Not started",
        "in_progress": "In progress",
        "approved": "Approved",
        "rejected": "Rejected",
        "skipped": "Skipped"
    },
    "trip_folder_request": "Trip folder",
    "trip_folder_request_desc": "Create folder to group trip expenses",
    "trip_folder_title": "Folder information",
    "trip_folder_info": "Travel & Mileage reimbursements made easy",
    "trip_folder_request_info": {
        "step_1": "Please create a folder and save it",
        "step_2": "Cost center 1 and 2, as well as Expense Accounts set here will be pre-filled when you create requests from inside this folder.",
        "step_3": "Please only submit this folder after collecting all your trip-related expenses and reimbursement requests.",
        "step_4": "You can create new requests from inside this folder, e.g. mileage or per diem reimbursements, regular reimbursements, invoice requests, etc.",
        "step_5": "Additionally, you can attach existing requests to your folder, e.g. card requests, an invoice request for a hotel expense, etc.",
        "step_6": "Submit your folder, when you have added all existing, as well as created all new trip-related requests.",
        "step_7": "Please make sure to add you bank details to your employee profile, so that you can receive reimbursement payments."
    },
    "draft_trip_folder": "Trip folder drafts",
    "draft": "Draft",
    "trip_folder": "Trip Folder",
    "shared": "Shared",
    "free_delivery": "Free Delivery",
    "allow_expense_account_code_special_characters": "Allow special characters for expense account codes",
    "personio": {
        "title": "Personio",
        "importedTooltip": "This employee has been fetched from Personio.",
        "easily_setup": "Easily connect Personio and finway to synchronize employee data and absences.",
        "how_to_obtain_client_id": "How to obtain a client ID?",
        "enable_absence_sync": {
            "title": "Sync absences",
            "tooltip": "If “Sync absences” is active, employees with an absence on Personio will also show as absent on finway. If a workflow is affected by an absence, the fallback approval process will be triggered."
        },
        "enable_create_employee": {
            "title": "Import new employees",
            "tooltip": "If “Import new employees” is active, employees on Personio that are not yet on finway will be added to your finway account automatically."
        },
        "enable_employee_sync": {
            "title": "Update existing employees",
            "tooltip": "If “Update existing employees” is active, finway will update employee information that was changed on the employee profile on Personio."
        },
        "enable_team_sync": {
            "title": "Add teams",
            "tooltip": "If “Add teams” is active, a “department” on Personio which is not yet a “team” on finway will automatically be created."
        },
        "settings": {
            "title": "Settings",
            "employee_email_required": "Please make sure that all users intended for synchronization have an email address configured in Personio."
        },
        "exclusion_list": "Exclusion list",
        "exclusion_list_explanation": "Please add the user email addresses you want to exclude from the Personio synchronization.",
        "excludedUser_one": "Excluded user ({{count}})",
        "excludedUser_other": "Excluded users ({{count}})"
    },
    "sso": {
        "title": "Single Sign-On (SSO)",
        "text": "Choose the Single Sign-On (SSO) provider you would like to (de)activate: ",
        "providers": {
            "google": {
                "title": "Google",
                "desc": "Allow your users to login with Google"
            },
            "azure_ad": {
                "title": "Microsoft Entra ID",
                "desc": "Allow your users to login with Microsoft Entra ID"
            },
            "okta": {
                "title": "Okta",
                "desc": "Allow your users to login with Okta"
            }
        },
        "how_to_obtain_client_id": "How to obtain a client ID?",
        "config": {
            "origins": "Authorized JavaScript origins",
            "redirects": "Authorized redirect URIs"
        },
        "easily_setup": "Easily setup your own SSO connection in a couple of steps.",
        "connection": {
            "successfully_setup": "Successfully setup {{providerName}} connection",
            "test": "Verify that your connection is correctly setup and running by clicking the button bellow"
        },
        "enforce": "Enforce the use of SSO",
        "warning": {
            "title": "Warning",
            "enforce": "This will force all users to login with SSO options exclusively. All users that are not inside your SSO connection will lose access. Are you sure about this?",
            "deforce": "This will no longer force all users to login with SSO. Are you sure about this?"
        }
    },
    "mfa": {
        "title": "Multi-Factor-Authentication (MFA)",
        "enforce": "Enforce the use of MFA",
        "warning": {
            "title": "Warning",
            "enforce": "This will require from all users to setup and use a MFA option. Are you sure about this?",
            "deforce": "This will no longer require all users to have a MFA option. Are you sure about this?"
        },
        "reset_for_user": {
            "button": "Reset MFA",
            "desc": "This will reset the users MFA configurations in case he/she has them"
        }
    },
    "change_history": "Change history",
    "type_x_to_proceed": "Type {{string}} to proceed",
    "copy": "Copy",
    "learn_more": "Learn more",
    "coming_soon": "Coming soon",
    "back_to_login": "Back to login",
    "billable": "Billable",
    "vendor_data_changed": "We've noticed a discrepancy between the vendor master data and the vendor's information on this request. Click this button to sync the request with the vendor master data.",
    "resources": {
        "expense": "Requests",
        "vendor": "Vendors",
        "costcenter": "Cost centers",
        "subscription": "Subscription",
        "costcenter2": "Cost centers 2",
        "user": "Users",
        "matchingtransaction": "Transactions",
        "companysettings": "Companies",
        "role": "Roles",
        "wallet": "Wallets",
        "bankconnection": "Bank connections",
        "card": "Cards",
        "corporate": "Corporates",
        "expensetag": "Expense tags",
        "inboxinvoice": "Inbox invoices",
        "tax": "Taxes",
        "team": "Teams",
        "workflow": "Workflows",
        "csvtemplate": "CSV templates",
        "expenseaccount": "Expense accounts",
        "vendorpayment": "Vendor payments",
        "purchaseorder": "Purchase orders"
    },
    "export_history": {
        "title": "Export history",
        "export_date": "Export date",
        "resource": "Resource",
        "format": "Format",
        "download": "Download",
        "status": {
            "title": "Status",
            "done": "Done",
            "processing": "Processing",
            "failed": "Failed",
            "partially_failed": "Partially failed"
        },
        "actions": "Actions",
        "validation": {
            "title_format": "Export validation for {{format}}",
            "title": "Export validation",
            "expense": "Expense",
            "status": "Status",
            "message": "Message",
            "success_message": "Validation passed"
        }
    },
    "duo_import_protocol": {
        "title": "DUO import protocol",
        "type": "Type",
        "filename": "Filename",
        "text": "Text",
        "time": "Time"
    },
    "expense_status": {
        "purchase_pending": "Purchase approval pending",
        "docs_needed": "Documents needed",
        "invoice_pending": "Invoice approval pending",
        "approved": "In review",
        "reviewed": "Reviewed",
        "paid": "Paid",
        "done": "Exported",
        "declined": "Declined"
    },
    "user_password_reset": {
        "title": "Force password reset for user",
        "explainer": "If the user has a password currently set, it will be reset and the user will be forced to create a new one. This will also automatically revoke all current sessions of this user"
    },
    "unblock_user": {
        "title": "Unblock the user if he's blocked",
        "explainer": "When a user is blocked due to the user providing an excessive number of incorrect credentials, you can use this modal to unblock them"
    },
    "multi_currency_wallet": "Multi currency wallet",
    "account_number": "Account number",
    "sort_code": "Sort code",
    "gobd": {
        "enforce_belegfunktion": "Enforce GoBD-compliance",
        "invoice_compliance_date": "CPU date"
    },
    "happy_easter": "Happy Easter!",
    "email_forwarding_address": "Email forwarding address",
    "comments_and_mentions": "Comments & Mentions",
    "inbox_invoice": "Inbox invoice",
    "reset_demo_data": "Reset demo data",
    "root_user_email_reverification": "Cards root user email verification",

    "cs_feature_flags": {
        "export_api": "Enable Export API for this customer instance",
        "personio_integration": "Enable Personio Integration for this customer instance",
        "owt": "Enable Outgoing Wire Transfer for this customer instance",
        "p2p": "Enable P2P for this customer instance",
        "purchase_requests": "Enable Purchase Requests for this customer instance",
        "vendor_payment_netting": "Enable Vendor Payment Netting (beta) for this customer instance"
    },
    "datev_csv_config": {
        "title": "Accounts for DATEV CSV wallet & account length",
        "info": "Please enter the DATEV account numbers for the finway wallet account and the cash transit account in the respective field (e.g. 1460 cash transit in SKR04)."
    },
    "datev_client_and_consultant": {
        "title": "DATEV client number & consultant number",
        "info": "Please add your DATEV client number & consultant number"
    },
    "date_format": {
        "month_year": "MM/YYYY"
    },
    "e_invoice_type": {
        "commercial_invoice": "Commercial invoice",
        "insurance": "Insurance",
        "corrected_invoice": "Corrected invoice",
        "request_for_payment": "Request for payment",
        "debit_note_goods_services": "Debit note (goods/services)",
        "metered_services_invoice": "Metered services invoice",
        "debit_note_financial_adjustments": "Debit note (financial adjustments)",
        "tax_notification": "Tax notification",
        "final_payment_request": "Final payment request",
        "payment_request_completed_units": "Payment request for completed units",
        "commercial_invoice_with_packing": "Commercial invoice with packing list",
        "commission_note": "Commission note",
        "debit_note": "Debit note",
        "prepayment_invoice": "Prepayment invoice",
        "tax_invoice": "Tax invoice",
        "factored_invoice": "Factored invoice",
        "consignment_invoice": "Consignment invoice",
        "forwarders_invoice_discrepancy": "Forwarder's invoice discrepancy report",
        "forwarders_invoice": "Forwarder's invoice",
        "freight_invoice": "Freight invoice",
        "claim_notification": "Claim notification",
        "consular_invoice": "Consular invoice",
        "partial_construction_invoice": "Partial construction invoice",
        "partial_final_construction_invoice": "Partial final construction invoice",
        "final_construction_invoice": "Final construction invoice",
        "invoice": "Invoice"
    },
    "vat_breakdown": "VAT breakdown",
    "category": "Category",
    "tax_base_amount": "Tax base amount",
    "tax_amount": "Tax amount",
    "invoice_summary": "Invoice summary",
    "total_item_amount": "Total item amount",
    "total_surcharges": "Total surcharges",
    "total_discounts": "Total discounts",
    "subtotal_net_amount": "Subtotal (Net amount)",
    "total_vat_amount": "Total VAT amount",
    "subtotal_gross_amount": "Subtotal (Gross amount)",
    "advance_payments": "Advance payments",
    "amount_due": "Amount due",
    "itemized_charges": "Itemized charges",
    "net_price": "Net price",
    "qty": "Qty",
    "gross_price": "Gross price",
    "generated_by": "Generated by",
    "invoice_details": "Invoice details",
    "seller_information": "Seller information",
    "buyer_service_recipient": "Buyer/Service recipient",
    "vat_id": "VAT ID",
    "invoice_number": "Invoice number",
    "invoice_type": "Invoice type",
    "payment_terms": "Payment terms",
    "no_liability_message": "We accept no liability for the correctness of the data.",
    "update_sepa_version": "SEPA xml Version (pain.001.001.09)",
    "vendor_payment_netting": "Vendor payment netting",
    "new_feature": "New feature",
    "line_items": "Line items",
    "purchase_order_link_disabled": "To link this invoice to an existing PO, please add the line items.",
    "purchase_orders_selection_modal": {
        "title": "Purchase orders"
    },
    "po_link": {
        "auto_link_tooltip_title": "AI links the items for you 🚀",
        "auto_link_tooltip": "Lean back and let AI do its magic.",
        "auto_link_tooltip_title_coming_soon": "Auto-link items 🚀",
        "auto_link_tooltip_coming_soon": "Soon you will be able to let finway do the linking for you.",
        "auto_matching_in_progress": "AI is matching invoice items with orders...",
        "no_auto_match_results": "No item match could be derived by AI for the selected orders",
        "all_items_linked": "All items are already linked",
        "all_po_items_linked": "All purchase order items are already linked",
        "purchase_order_line_items": "Purchase order line items",
        "invoice_line_items": "Invoice line items",
        "unitPrice": "Unit price",
        "totalGross": "Total Gross",
        "quantity": "Quantity",
        "quantityReceived": "Quantity Received",
        "amountInvoiced": "Amount Invoiced",
        "item_linked_to_purchase_order": "Item is linked to {{po_number}}",
        "quantity_ordered": "Quantity ordered",
        "previously_received": "Previously received",
        "open_quantity": "Open quantity",
        "delivery_note_line_items": "Delivery note line items"
    },
    "linked_to_this_invoice": "Linked To This Invoice",
    "linked_to_this_delivery_note": "Linked To This Delivery Note",
    "purchase_orders": "Purchase orders",
    "purchase_order": "Purchase order",
    "embedded_attachments": "Embedded attachments",
    "purchase_order_short": "PO",
    "skr42": "SKR42 (associations)",
    "opos": {
        "title": "Open Items List",
        "filter": {
            "vendor": "Vendor",
            "dueDate": "Due date",
            "status": "Payment status",
            "marked_as_paid": "\"Marked as paid\" requests",
            "marked_as_paid.exclude": "Exclude from Open Items List"
        },
        "invoice_number": "Invoice number",
        "vendor_name": "Vendor",
        "vendor_creditor_number": "Creditor number",
        "invoice_date": "Invoice date",
        "due_date": "Due date",
        "due_today_short": "Today",
        "payment_terms": "Payment terms",
        "agreed_payment_conditions": "Agreed payment conditions",
        "original_amount": "Original amount",
        "open_amount": "Open amount",
        "open_amount_net": "Open amount (net)",
        "open_amount_gross": "Open amount (gross)",
        "currency": "Currency",
        "status": {
            "open": "Open",
            "due": "Overdue",
            "overdue": "Overdue",
            "paid": "Paid",
            "failed": "Failed"
        },
        "days_overdue": "Days overdue",
        "expense_accounts": "Expense account",
        "performance_date": "Performance date",
        "request": "Request",
        "open_amount_gross_total": "Open amount (gross)",
        "open_amount_with_skonto_gross": "Open amount with Skonto (gross)",
        "currency_total": "{{currency}} Total",
        "invoices_count": "{{count}} invoices",
        "show_skonto": "Show with discount",
        "savings": "Saving",
        "discount_percent": "Discount %",
        "discount_due_date": "Discount due date",
        "total_gross_with_discount": "Total gross with discount",
        "refund": "Refund",
        "action": "Action",
        "clear_item": "Clear item",
        "tabs": {
            "open_items": "Open items",
            "excluded": "Excluded items"
        }
    },
    "self_issued_receipt": "Self-issued receipt",
    "vendor_payments": {
        "documents_netted_one": "{{count}} document netted into 1 payment",
        "documents_netted_other": "{{count}} documents netted into 1 payment",
        "method": "Method",
        "net_payment": "Net payment",
        "subject_line": "Description",
        "new": "New",
        "promo_title": "Pay each vendor once - automatically",
        "promo_description": "finway can net a supplier's open invoices and credit notes into a <0>single payment per vendor</0>, while keeping every accounting document separate and auditable.",
        "promo_netted_per_vendor": "Invoices and supplier credit notes netted per vendor",
        "promo_one_payment": "One SEPA payment, fully reconstructable for GoBD",
        "promo_card_excluded": "Card credit notes excluded automatically",
        "promo_example_vendor": "Muster GmbH",
        "promo_example_documents": "#33 - 2 invoices, 1 credit note",
        "promo_example_net": "net payable",
        "promo_example_invoice": "Invoice {{number}}",
        "promo_example_credit_note": "Credit note {{number}}",
        "title": "Vendor payments",
        "invoice_count_one": "{{count}} invoice",
        "invoice_count_other": "{{count}} invoices",
        "credit_note_count_one": "{{count}} credit note",
        "credit_note_count_other": "{{count}} credit notes",
        "pending_credit_notes_one": "{{count}} credit note not approved",
        "pending_credit_notes_other": "{{count}} credit notes not approved",
        "excluded": "Excluded",
        "pending": "Pending",
        "excluded_credit_notes": "Excluded credit notes",
        "block_reason": {
            "credit_exceeds_invoices": "Credit notes exceed the invoices",
            "credit_equals_invoices": "Credit notes amount equals invoice amount",
            "no_invoices": "No invoice selected",
            "missing_iban": "Vendor IBAN missing"
        },
        "single_title": "Vendor payment",
        "system": "System",
        "status": {
            "approved": "Approved",
            "payment_initiated": "Payment started",
            "exported": "Exported",
            "paid": "Paid",
            "failed": "Failed",
            "cancelled": "Cancelled"
        },
        "log": {
            "created": "Created",
            "approved": "Approved",
            "payment_initiated": "Payment started",
            "exported": "Exported as SEPA XML",
            "paid": "Paid",
            "payment_failed": "Payment failed",
            "cancelled": "Cancelled",
            "matched": "Matched to bank transaction",
            "unmatched": "Unmatched from bank transaction",
            "document_reset": "Document reset"
        }
    }
}
